var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      directives: [
        {
          name: "b-tooltip",
          rawName: "v-b-tooltip",
          value: { title: _vm.tooltipText },
          expression: "{ title: tooltipText }",
        },
      ],
      staticClass: "status value-item",
      class: _vm.statusItemClass,
      on: { click: _vm.handleStatusClick },
    },
    [
      _c("div", { staticClass: "status-inner-wrapper" }, [
        _c(
          "div",
          { staticClass: "status-inner" },
          [
            _vm.customRender
              ? _vm._t("default", null, { step: _vm.stepValue })
              : _c("span", [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm._f("truncateText")(
                          _vm.stepValue.value,
                          _vm.TEXT_LIMIT
                        )
                      ) +
                      "\n      "
                  ),
                ]),
          ],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }